"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WayPointRow = WayPointRow;
var _DragIndicator2 = _interopRequireDefault(require("@mui/icons-material/DragIndicator"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _autocomplete = require("./autocomplete");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function WayPointRow(_ref) {
  let {
    defaultOptions: _defaultOptions,
    size,
    readonly,
    draggable,
    map,
    mapHasContextMenu,
    geolocation,
    userPlaces,
    wayPoints,
    index,
    onBlur,
    onChange
  } = _ref;
  const [defaultOptions, setDefaultOptions] = (0, _react.useState)();
  const [defaultValue, setDefaultValue] = (0, _react.useState)(wayPoints[index] || null);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const prevWayPoints = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    const defaultOptions = [];
    if (_defaultOptions) {
      defaultOptions.push(..._defaultOptions);
    } else {
      if (geolocation) defaultOptions.push(geolocation);
      if (userPlaces) defaultOptions.push(...userPlaces);
    }
    setDefaultOptions(defaultOptions);
  }, [_defaultOptions, geolocation, userPlaces]);
  (0, _react.useEffect)(() => {
    const wayPoint = wayPoints[index];
    if (prevWayPoints.current?.[index] !== wayPoint) setDefaultValue(wayPoint ? wayPoint.clone() : null);
    prevWayPoints.current = wayPoints;
  }, [wayPoints]);
  function handleWayPointChange(place) {
    onChange?.(index, place || undefined);
    document.getElementById(`way-point-${index}-autocomplete`)?.blur();
  }
  function handleBlur() {
    onBlur?.(index);
  }
  const placeholder = t(index === 0 && !wayPoints[0] ? 'commons.routing.actions.search_departure_or_click' : wayPoints.length === 2 && index === 1 && wayPoints[0] && !wayPoints[1] ? 'commons.routing.actions.search_arrival_or_click' : mapHasContextMenu && wayPoints.length === 2 && index === 1 && !wayPoints[0] && !wayPoints[1] ? 'commons.routing.actions.search_arrival_or_right_click' : 'commons.actions.search_address', {
    context: index === 0 && !wayPoints[0] && !map ? 'no_map' : ''
  });
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: [draggable ? 'shifted' : '', readonly ? 'readonly' : ''].filter(Boolean).join(' ')
  }, draggable && /*#__PURE__*/_react.default.createElement(StyledDragIcon, {
    className: "drag-icon",
    color: "action",
    fontSize: "small"
  }), readonly ? wayPoints[index] ? /*#__PURE__*/_react.default.createElement(StyledRow, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    title: wayPoints[index]?.address,
    variant: "body2"
  }, wayPoints[index]?.address)) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    component: "div",
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  })) : /*#__PURE__*/_react.default.createElement(_autocomplete.Autocomplete, {
    disableFloatingLabel: true,
    hideCustomOptionsOnSearch: true,
    center: map?.getCenter(),
    customOptions: defaultOptions,
    defaultValue: defaultValue,
    id: `way-point-${index}-autocomplete`,
    inputProps: {
      InputProps: {
        sx: {
          '&&': {
            borderRadius: '10px',
            backgroundColor: '#fff',
            paddingX: 1.5,
            paddingY: 0.5
          }
        },
        title: placeholder
      },
      onBlur: handleBlur,
      placeholder,
      label: undefined,
      margin: 'none',
      variant: 'outlined'
    },
    margin: "none",
    onSelect: handleWayPointChange,
    size: size
  }));
}
const Wrapper = _styledComponents.default.div`
  align-items: center;
  display: flex;
  height: 44px;
  padding-left: 24px;
  position: relative;

  &.readonly {
    height: 44px;
  }

  &.shifted {
    padding-left: 24px;
  }

  .drag-icon {
    visibility: hidden;
  }

  &:hover {
    .drag-icon {
      visibility: visible;
    }
  }
`;
const StyledDragIcon = (0, _styledComponents.default)(_DragIndicator2.default)`
  left: 0px;
  position: absolute;
`;
const StyledRow = _styledComponents.default.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  height: 44px;
  justify-content: space-between;
  overflow-x: hidden;

  button {
    margin-left: 8px;
  }
`;